<template>
  <div class="home">
    <HeroSection />
    
    <!-- <div class="container">
      <div class="content-wrapper"> -->
     
        
          <CategoryFilter />
          <BrandFilter />
        
        <main class="main-content">
          <ProductGrid />
        </main>
      <!-- </div>
    </div> -->
  </div>
</template>

<script>
import HeroSection from '../components/layout/HeroSection.vue'
import CategoryFilter from '../components/common/CategoryFilter.vue'
import BrandFilter from '../components/common/BrandFilter.vue'
import ProductGrid from '../components/layout/ProductGrid.vue'

export default {
  name: 'Home',
  components: {
    HeroSection,
    CategoryFilter,
    BrandFilter,
    ProductGrid
  },
  mounted() {
    // Initialize filtered products
    this.$store.dispatch('products/filterProducts')
  }
}
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.content-wrapper {
  display: grid;
  grid-template-columns: 250px 1fr;
  gap: 30px;
  padding: 30px 0;
}

.main-content {
  min-height: 600px;
}

@media (max-width: 1024px) {
  .content-wrapper {
    grid-template-columns: 200px 1fr;
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .content-wrapper {
    grid-template-columns: 1fr;
  }
  
  .sidebar {
    order: 2;
  }
  
  .main-content {
    order: 1;
  }
}
</style>